angular
    .module('propagandaManuscriptControlModule', [
        'propagandaManuscriptControlLeftModule',
        'propagandaManuscriptControlRouterModule',
        'propagandaManuscriptServiceModule',
        'propagandaManuscriptPreviewModule',
    ])
    .controller('propagandaManuscriptControlCtrl', [
        '$scope',
        '$q',
        '$modal',
        '$state',
        'trsHttpService',
        'modalDialog',
        'trsspliceString',
        'initSingleSelecet',
        'resCtrModalService',
        '$stateParams',
        'resourceCenterService',
        'storageListenerService',
        'localStorageService',
        '$filter',
        'propagandaManuscriptService',
        'messagePublishService',
        function(
            $scope,
            $q,
            $modal,
            $state,
            trsHttpService,
            modalDialog,
            trsspliceString,
            initSingleSelecet,
            resCtrModalService,
            $stateParams,
            resourceCenterService,
            storageListenerService,
            localStorageService,
            $filter,
            propagandaManuscriptService,
            messagePublishService,
        ) {
            initStatus();
            initData()
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 1,
                };

                $scope.status = {
                    copyCurrPage: 1,
                    id: $stateParams.docid,
                    isUGC: true,
                    btnRights: {},
                };

                $scope.data = {
                    keywords: '',
                    items: [],
                    selectedArray: [],
                    selectedPanel: [],
                    operFlags: [],
                };

                $scope.params = {
                    serviceid: 'mlf_pm',
                    methodname: 'getPMLibList',
                    groupId: $stateParams.groupid,
                    // CURRPAGE: $scope.page.CURRPAGE,
                    // PAGESIZE: $scope.page.PAGESIZE,
                };

                $scope.iWoDocStatusName = initSingleSelecet.iWoDocType().filter((item) => item.value == 1 || !item.value);
                $scope.iWoDocStatusSelected = angular.copy($scope.iWoDocStatusName[0]);
            }
            function initData() {
                initBtnRight();
                requestData().then(function() {
                    getLocalStorageForData($scope.data.items);
                });
                messagePublishService.subscribe('secondLevelChange', function(e, data) {
                    if($scope.params.groupId !== data.ID) {
                        requestData().then(function() {
                            getLocalStorageForData(data.ID);
                        });
                    } 
                },
                $scope);             
            }

            /**
             * [initBtnRight description] 获取按钮权限
             * @return {[type]} [description]null
             */
            function initBtnRight() {
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeysOfNormalModal',
                    ModalName: '资源中心',
                    Classify: 'source.pmdocs',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    angular.forEach(data, function(value, key) {
                        $scope.status.btnRights[value.OPERNAME] = value;
                    });
                });
            }

            /**
             * [requestData 获取稿库分组数据]
             * @return {[type]} [description]
             */
            function requestData() {
                var defer = $q.defer();
                $scope.params.StartTime = '';
                $scope.params.EndTime = '';
                if ($scope.data.fromdate && $scope.data.untildate) {
                    $scope.params.StartTime = $scope.data.fromdate + ' 00:00:00';
                    $scope.params.EndTime = $scope.data.untildate + ' 23:59:59';
                }
                $scope.data.keywords === '' ? delete $scope.params.SearchValue : ($scope.params.SearchValue = $scope.data.keywords);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                    if (data.CODE == 200) {
                        $scope.data.items = data.DATA;
                        defer.resolve(data.DATA);
                    } else {
                        modalDialog.alertType(data.MESSAGE, '', 'error', false, '');
                        defer.reject();
                    }
                });
                return defer.promise;
            }

            /**
             * [getLocalStorageForData 根据缓存的记录展开面板]
             * @param  {[type]} data [description]
             * @return {[type]}      [description]
             */
            function getLocalStorageForData(data) {
                var localStorage = JSON.parse(localStorageService.get('propagandaManuscriptPanel'));
                if ($scope.data.items.length > 0) {
                    var selectedPanel = localStorage[$stateParams.id];
                    if (angular.isUndefined(selectedPanel)) {
                        return;
                    }
                    for (var i = 0; i < selectedPanel.length; i++) {
                        for (var k = 0; k < $scope.data.items.length; k++) {
                            if (selectedPanel[i] == $scope.data.items[k].TIME) {
                                $scope.selectPanel($scope.data.items[k]);
                                break;
                            }
                        }
                    }
                }
            }

            /**
             * [getListData 获取稿件数据]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            function getListData(item) {
                var params = angular.copy($scope.params);
                params.GroupId = params.groupId;
                delete params.groupId;
                params.serviceid = 'mlf_pm';
                params.methodname = 'getTmyPMDataByDate';
                params.StartTime = item ? item.TIME : $scope.data.fromdate;
                params.EndTime = item ? item.TIME : $scope.data.untildate;
                params.StartTime = params.StartTime + ' 00:00:00';
                params.EndTime = params.EndTime + ' 23:59:59';
                // $scope.data
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.CODE == 200) {
                        item.DOCS = angular.forEach(data.DATA.content, function(item, index) {
                            item.METADATAID = item.docid;
                            // item.imgurl = thumbnail(item.picList);
                            item.DOCTYPEID = item.doctype;
                            item.CRTIME = item.crtime;
                        });
                        if (item.DOCS.length > 0) {
                            initFlag(item.DOCS);
                            getDraftRecord(item.DOCS);
                        }
                        $scope.status.flag = true;
                    } else {
                        modalDialog.alertType(data.MESSAGE, '', 'error', false, '');
                        // defer.reject();
                    }
                });
            }

            /**
             * [singleSelectedDoc description] 单选
             * @param  {[type]} item [description] 当前数据
             * @return {[type]}      [description]
             */
            $scope.singleSelectedDoc = function(item) {
                var index = $scope.data.selectedArray.indexOf(item);
                index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
            };

            /**
             * [selectedAllDoc description] 全选当前面板的稿件
             * @param  {[type]} items [description] 当前面板
             * @return {[type]}       [description]
             */
            $scope.selectedAllDoc = function(items) {
                if (!!items) {
                    var panelAllSelected = true;
                    for (var i = 0; i < items.length; i++) {
                        if ($scope.data.selectedArray.indexOf(items[i]) < 0) {
                            $scope.data.selectedArray.push(items[i]);
                            panelAllSelected = false;
                        }
                    }
                    if (panelAllSelected === true) {
                        for (var j = 0; j < items.length; j++) {
                            if ($scope.data.selectedArray.indexOf(items[j]) > -1) {
                                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(items[j]), 1);
                            }
                        }
                    }
                }
            };

            /**
             * [initFlag description]
             * @return {[type]} [description]
             */
            function initFlag(items) {
                var ids = trsspliceString.spliceString(items, 'docid', ',');
                var params = {
                    serviceid: 'mlf_pm',
                    methodname: 'queryFlag',
                    dataIds: ids,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    var temp = data;
                    for (var i in temp) {
                        if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                            $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                        }
                    }
                });
            }

            /**
             * [panelIsSelected description] 当前面板稿件是否全部选中
             * @param  {[type]} items [description] 当前面板
             * @return {[type]}       [description]
             */
            $scope.panelIsSelected = function(items) {
                if (!items) {
                    return false;
                }
                if (items.length === 0) {
                    return false;
                }
                for (var i = 0; i < items.length; i++) {
                    if ($scope.data.selectedArray.indexOf(items[i]) < 0) {
                        return false;
                    }
                }
                return true;
            };

            /**
             * [selectPanel 选择面板]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.selectPanel = function(item) {
                var n = $scope.data.selectedPanel.indexOf(item.TIME);
                if (n > -1) {
                    if ($scope.status.flag) {
                        $scope.data.selectedPanel.splice(n, 1);
                    } else {
                        getListData(item);
                    }
                } else {
                    $scope.data.selectedPanel.push(item.TIME);
                    getListData(item);
                }
                var obj = {};
                obj[$stateParams.id] = $scope.data.selectedPanel;
                localStorageService.set('propagandaManuscriptPanel', JSON.stringify(obj));
            };

            /**
             * [getType 获取稿件类型名字]
             * @param  {[type]} type [description]
             * @return {[type]}      [description]
             */
            $scope.getType = function(type) {
                var typeName = $scope.iWoDocStatusName.filter(function(item) {
                    return item.value == type;
                })[0];
                return typeName ? typeName.name : '';
            };

            /**
             * [querySearch 快速检索]
             * @return {[type]} [description]
             */
            $scope.querySearch = function(event) {
                if (!!event && event.keyCode == 13) {
                    requestData().then(function(data) {
                        $scope.status.flag = false;
                        if (data.length > 0) {
                            $scope.selectPanel($scope.data.items[0]);
                        }
                    });
                } else if (!event) {
                    requestData().then(function(data) {
                        $scope.status.flag = false;
                        if (data.length > 0) {
                            $scope.selectPanel($scope.data.items[0]);
                        }
                    });
                }
            };

            /**
             * [viewRequest 查看要求]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.viewRequest = function(item) {
                propagandaManuscriptService.viewRequest(item.id, item.title).then(function(data) {});
            };

            /**
             * [fetchManuscript 取稿]
             * @return {[type]} [description]
             */
            $scope.fetchManuscript = function() {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                    return;
                }
                if (!selectedSingleDoctype()) {
                    modalDialog.alertType('批量取稿只允许选择一种稿件类型', '', 'error', 'confirm', function() {});
                    return;
                }
                var ids = trsspliceString.spliceString($scope.data.selectedArray, 'id', ',');
                var params = {
                    serviceid: 'mlf_pm',
                    methodname: 'takPMDocs',
                    PMIds: ids,
                    SourceName: '资源中心-宣传部稿库-收到',
                };
                var isOnlyOne = !(ids.split(',').length > 1);
                var modalInstance = resCtrModalService.fullTakeDraft(params, isOnlyOne, $scope.data.selectedArray, $scope.status.isUGC, false);
                modalInstance.result.then(
                    function() {
                        initFlag($scope.data.selectedArray);
                        getDraftRecord($scope.data.selectedArray);
                        // initOperFlag($scope.data.selectedArray);
                        // getDraftRecord($scope.data.selectedArray);
                        $scope.data.selectedArray = [];
                    },
                    function() {
                        // initOperFlag($scope.data.selectedArray);
                        // getDraftRecord($scope.data.selectedArray);
                        $scope.data.selectedArray = [];
                    }
                );
            };

            /**
             * [getDraftRecord 取稿记录]
             * @param  {[type]} items [description]
             * @return {[type]}       [description]
             */
            function getDraftRecord(items) {
                var ids = trsspliceString.spliceString(items, 'docid', ',');
                var params = {
                    serviceid: 'mlf_pm',
                    methodname: 'queryQuOpersList',
                    dataIds: ids,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    // for (var i = 0; i < items.length; i ++) {
                    //     items[i].OPERUSER = data[items[i].id][0].OPERUSER;
                    // }
                    for (var i = 0; i < items.length; i++) {
                        var operUsers = data[items[i].docid];
                        operUsers = $filter('unique')(operUsers, 'OPERUSER');
                        items[i].OPERUSER = trsspliceString.spliceString(operUsers, 'OPERUSER', ' ').split(' ');
                    }
                });
            }

            /**
             * [showOperFlag description] 显示取签见撤重标志
             * @param  {[type]} guid      [description] 稿件id
             * @param  {[type]} flagIndex [description] 取签见撤重序号
             * @return {[type]}           [description]
             */
            $scope.showOperFlag = function(guid, flagIndex) {
                // share
                var temp = queryItemBYID(guid);
                if (!!temp) {
                    return queryItemBYID(guid).OPERFLAG.substr(flagIndex, 1) == '1';
                } else {
                    return false;
                }
            };

            /**
             * [queryItemBYID description] 根据guid获取在WCM内的取签见撤重的二进制数
             * @param  {[type]} guid [description] 稿件id
             * @return {[type]}      [description]
             */
            function queryItemBYID(guid) {
                for (var i in $scope.data.operFlags) {
                    if (guid == $scope.data.operFlags[i].PMID) {
                        return $scope.data.operFlags[i];
                    }
                }
            }

            /**
             * [queryByTime description] 根据时间搜索
             */
            $scope.queryByTime = function() {
                requestData();
            };

            /**
             * [selectedDoctype description] 判断选中稿件是否属于同一类型openTakeDraftModal
             * @return {[type]} [description]
             */
            function selectedSingleDoctype() {
                var doctype = $scope.data.selectedArray[0].type;
                for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                    if (doctype != $scope.data.selectedArray[i].type) {
                        return false;
                    }
                }
                return true;
            }

            /**
             * [viewBigDataInfo description] 取签见撤重 点击弹出
             * @param  {[type]} ChnlDocId  [description] 稿件id
             * @param  {[type]} showRepeat [description] 类型
             * @return {[type]}            [description]
             */
            $scope.viewInfo = function(ChnlDocId, showRepeat, showClick, isUGC, isTenant) {
                var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
                var params = {
                    serviceid: 'mlf_PluralisticShare',
                    methodname: 'queryFlagList',
                    dataId: ChnlDocId,
                };
                var infoModal = resCtrModalService.infoModal(ChnlDocId, showRepeat, showClick, operFlags, false, false, true);
            };

            /**
             * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
             * @param  {[type]} guid [description] 稿件id
             * @return {[type]}      [description]
             */
            function queryItemBYGUID(guid) {
                for (var i in $scope.data.operFlags) {
                    if (guid == $scope.data.operFlags[i].PMID) {
                        return $scope.data.operFlags[i];
                    }
                }
            }

            /**
             * [CreationAxis 个人素材]
             */
            $scope.CreationAxis = function() {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                    return;
                }
                for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                    if ($scope.data.selectedArray[i].type > 2) {
                        modalDialog.alertType('只能添加新闻和图集!', '', 'error', false, '');
                        return;
                    }
                }
                var ids = trsspliceString.spliceString($scope.data.selectedArray, 'id', ',');
                var params = {
                    serviceid: 'mlf_pm',
                    methodname: 'PMDocAddPersonalMaterialOfTxt',
                    ids: ids,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    if (data.message) {
                        modalDialog.alertType('', data.message, 'error', false, function() {
                            $scope.data.selectedArray = [];
                        });
                    } else {
                        modalDialog.alertType('添加成功!', '', 'success', false, function() {
                            $scope.data.selectedArray = [];
                        });
                    }
                });
            };

            $scope.propagandaManuscriptPreview = function(item) {
                storageListenerService.previewPageTurningStorage(item, 'id, docid', 'propagandaManuscriptPreview');
            };
        },
    ]);
